import { PropsWithChildren } from 'react';
import { IntercomProvider } from 'react-use-intercom';

import { useConfig } from '~/components/ConfigProvider';
import { useRuntime } from '~/components/RuntimeProvider';

export const IntercomProviderConfigurable = ({ children }: PropsWithChildren) => {
  const { intercom } = useConfig();
  const { runtime, loading } = useRuntime();

  const shouldInitialise = !loading && intercom.enabled && runtime.type !== 'browserExtension';

  return (
    <IntercomProvider shouldInitialize={shouldInitialise} appId={intercom.appId || ''} apiBase={intercom.apiBase}>
      {children}
    </IntercomProvider>
  );
};
